import http from "@/http";
import * as types from "./types";

const actions = {
  [types.GET_MATERIALS_BY_MODEL]() {
    const domain = this.state.utils.configuration.domain || process.env.VUE_APP_DOMAIN;
    const model = this.state.utils.pdm.sku;
    const bucket = this.state.endPoints.customizer.swatchMaterialGroups;
    const url = `${bucket}${model}`;
    return new Promise((resolve, reject) => {
      http.get(url)
        .then((response) => {
          resolve(response.data);
        })
        .catch(reject);
    });
  },
  [types.GET_MATERIALS_BY_NAME]({ rootState }, { materialName}) {
    const bucket = this.state.endPoints.customizer.swatchMaterials;
    const url = `${bucket}${materialName}`;
    return http.get(url);
  }
};

export default actions;
